module.exports = __webpack_public_path__ + "img/abstract-planes-bright.467e8f2d.svg";